import React, { useState } from "react";
import { connect } from "react-redux";

import PatientFaqs from "./patientFaqs";
import DoctorFaqs from "./doctorFaqs";

const ViewFaqsPage = props => {
  const [activeTab, setActiveTab] = useState("patient");

  const switchFaqTab = tabName => {
    setActiveTab(tabName);
  };

  return (
    <div className="view-ticket-container faq-page-container">
      <div className="row">
        <h3 className="col-md-12">FAQs</h3>
      </div>
      <div className="row col-md-12 mt-4">
        <div className="faq-tab-container col-md-12 d-flex flex-row justify-content-center">
          <p
            className={
              activeTab === "patient" ? "faq-tab active-tab" : "faq-tab"
            }
            onClick={e => {
              e.preventDefault();
              switchFaqTab("patient");
            }}
          >
            Patient FAQ
          </p>
          <p
            className={
              activeTab === "doctor" ? "faq-tab active-tab" : "faq-tab"
            }
            onClick={e => {
              e.preventDefault();
              switchFaqTab("doctor");
            }}
          >
            Doctor FAQ
          </p>
        </div>
        {activeTab === "patient" && (
          <PatientFaqs
            faqs={
              props.serverConstants ? props.serverConstants.patientFaqs : []
            }
          />
        )}
        {activeTab === "doctor" && (
          <DoctorFaqs
            faqs={props.serverConstants ? props.serverConstants.doctorFaqs : []}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  serverConstants: state.serverConstants.constants
});

export default connect(mapStateToProps, null)(ViewFaqsPage);
